const trimTrailingSlash = (value: string | undefined) => value?.replace(/\/+$/, "") ?? ""

export const buildConsumerRestaurantUrl = (
  consumerBaseUrl: string | undefined,
  restaurantId: string
) => {
  const normalizedBaseUrl = trimTrailingSlash(consumerBaseUrl)
  if (!normalizedBaseUrl) {
    return null
  }

  return `${normalizedBaseUrl}/restaurants/${restaurantId}`
}

export const buildConsumerTicketUrl = (
  consumerBaseUrl: string | undefined,
  restaurantId: string,
  ticketId: string
) => {
  const restaurantUrl = buildConsumerRestaurantUrl(consumerBaseUrl, restaurantId)
  if (!restaurantUrl) {
    return null
  }

  return `${restaurantUrl}/tickets/${ticketId}`
}
